var React = require('react');

function Image2 (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M19.5 10.4191L5.82963 14.082C3.1623 14.7968 1.57939 17.5384 2.2941 20.2058L13.6821 62.7065C14.3968 65.3738 17.1385 66.9568 19.8059 66.242L67 53.5964","stroke":"#989998","key":0}),React.createElement("rect",{"x":"19.5","y":"0.5","width":"70","height":"53","rx":"4.5","stroke":"#989998","key":1}),React.createElement("path",{"d":"M33 42L47.8787 27.1213C49.0503 25.9497 50.9497 25.9497 52.1213 27.1213L53.5 28.5M67 42L53.5 28.5M53.5 28.5L64.8787 17.1213C66.0502 15.9498 67.9497 15.9497 69.1213 17.1213L80.5 28.5","stroke":"#989998","key":2}),React.createElement("circle",{"cx":"33","cy":"12","r":"4.5","stroke":"#989998","key":3})]);
}

Image2.defaultProps = {"width":"90","height":"69","viewBox":"0 0 90 69","fill":"none"};

module.exports = Image2;

Image2.default = Image2;



//////////////////
// WEBPACK FOOTER
// ./node_modules/svg-react-loader/lib/loader.js!./src/icons/image-2.svg
// module id = 934
// module chunks = 0